export default __webpack_public_path__ + "static/media/inbal_michailovici.838a2e72.jpeg";